// Action Types
export const FETCH_MAKE_OPTIONS = 'FETCH_MAKE_OPTIONS';
export const FETCH_MODEL_OPTIONS = 'FETCH_MODEL_OPTIONS';
export const FETCH_YEAR_OPTIONS = 'FETCH_YEAR_OPTIONS';
export const FETCH_ENGINE_OPTIONS = 'FETCH_ENGINE_OPTIONS';
export const FETCH_VEHICLE_TYPE_OPTIONS = 'FETCH_VEHICLE_TYPE_OPTIONS';